import { useContext } from 'react'
import AuthContext from '../store/auth-context'

export const useAuthContext = () => {
    return useContext(AuthContext)
}
